import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import HeroSection from "./components/HeroSection";
import HotRevelations from "./components/HotRevelations";
import CategoryNav from "./components/CategoryNav";
import LatestNews from "./components/LatestNews";
import CommunityStats from "./components/CommunityStats";
import CTASection from "./components/CTASection";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "黑料社区",
  alternateName: "Heiliao Community",
  url: "https://heiliao.community",
  description: "黑料社区是专注于深度内幕、真实情报与用户自发揭秘的聚合社区平台。",
  potentialAction: {
    "@type": "SearchAction",
    target: "https://heiliao.community/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
  inLanguage: "zh-CN",
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "黑料社区",
  url: "https://heiliao.community",
  description: "深度内幕与真实情报聚合社区平台",
  foundingDate: "2021",
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer service",
    email: "contact@heiliao.community",
    availableLanguage: "Chinese",
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <HotRevelations />
        <CategoryNav />
        <LatestNews />
        <CommunityStats />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}